<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='1000px')
    v-card(grid-list-md)
      v-toolbar(dark, color='primary')
        v-toolbar-title {{ Lead.id }} - {{ $t('pageHeader.updateLead') }}
        v-spacer
        v-btn(icon, dark, @click='close()')
          v-icon close
      v-card-text
        v-container(grid-list-lg)
          v-layout(row wrap)
            v-flex(xs12)
              v-layout(row wrap) 
                v-flex(xs12 sm4)
                  v-autocomplete(v-model="Lead.reporterUserID"
                    :items="users"
                    :error-messages="reporterUserErrors"
                    item-text='fullName'
                    item-value="userID"
                    :label="$t('labels.leadFounder')")
                v-flex(xs12 sm4)
                  v-autocomplete(
                    :items="comboBoxByID(3).ComboBoxDetails"
                    :label="$t('labels.software')"
                    item-text="selector"
                    :error-messages="softwareErrors"
                    item-value="id" 
                    v-model="Lead.softwareID")
                v-flex(xs12 sm4)
                  DateTimePicker(:showIcon="false"
                    :range="false"
                    :clearable="false"
                    :hideTime="false"
                    label="Next follow up date"
                    v-on:input="setFollowingDate" 
                    :initStartDate="$moment(Lead.dueDate)" 
                    :noFuture="true")
            v-flex(xs12)
              v-divider
            v-flex(xs12)
              div Lead Detail
              v-layout(row wrap)                
                v-flex(xs12 sm3)
                  v-text-field(:error-messages="firstNameErrors" v-model="Lead.firstName" label='First name')  
                v-flex(xs12 sm3)
                  v-text-field(v-model="Lead.lastName" label='Last name')  
                v-flex(xs12 sm6)
                  v-text-field(v-model="Lead.businessName" label='Business name')  
                v-flex(xs12 sm3)
                  v-text-field(v-model="Lead.phoneNumber" label='Phone number')  
                v-flex(xs12 sm3)
                  v-text-field(v-model="Lead.email" label='Email address')
                v-flex(xs12 sm3)
                  v-text-field(v-model="Lead.locationCount" label='location count')     
                v-flex(xs12 sm3)
                  v-text-field(v-model="Lead.refer" label='Refer from')  
            v-flex(xs12)
              div Source
              v-layout(row wrap) 
                v-flex(xs12 sm3)
                  v-autocomplete(
                    :items="comboBoxByID(7).ComboBoxDetails"
                    :label="$t('labels.status')"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.statusID")
                v-flex(xs12 sm3)
                  v-autocomplete(
                    :items="comboBoxByID(5).ComboBoxDetails"
                    :label="$t('labels.source')"
                    :error-messages="sourceErrors"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.sourceID")
                v-flex(xs12 sm3)
                  v-autocomplete(
                    :items="comboBoxByID(8).ComboBoxDetails"
                    :label="$t('labels.foundUs')"
                    :error-messages="foundUsErrors"
                    item-text="selector"
                    item-value="id"
                    v-model="Lead.foundUsID")
                v-flex(xs12 sm3)
                  v-autocomplete(v-model="Lead.assignedToUserID"
                    :items="users"
                    :error-messages="assignedToErrors"
                    item-text='fullName'
                    item-value="userID"
                    :label="$t('labels.assignedTo')")
            v-flex(xs12)
              v-expansion-panel.elevation-0
                v-expansion-panel-content
                  div(slot="header")
                    span {{ $t('labels.address') }}
                  v-layout(row wrap)                
                    v-flex(xs12)
                      v-text-field(v-model="Lead.address" label='Address')  
                    v-flex(xs12 sm4)
                      v-text-field(v-model="Lead.city" label='City')  
                    v-flex(xs12 sm4)
                      v-text-field(v-model="Lead.state" label='State')  
                    v-flex(xs12 sm4)
                      v-text-field(v-model="Lead.zipcode" label='Zipcode')
            v-flex(xs12)
              v-layout(row wrap)
                v-flex(xs12)
                  v-textarea(counter v-model="Lead.notes" :label="$t('labels.notes')")

      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close()') Close
        v-btn(color='blue darken-1' dark @click='update()') Update
      
</template>

<script>
import { mapGetters } from 'vuex';
import locationService from '../../Location/service.js'
import LeadService from '../service.js'
import DateTimePicker from '../../Global/components/DateTimePicker'
import userService from '../../User/service.js'
const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
} = require('vuelidate/lib/validators')

export default {
  props: {
    editDialog: {
      default: false
    },
    lead: {
      type: Object,
      default: null
    },
  },
  name: 'create-Lead',
  data() {
    return {
      dialog: false,
      stores: [],
      users: [],
      Lead: {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email:null,
        businessName: null,
        notes: null,
        dueDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        statusID: 27,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        reporterUserID:  null,
        assignedToUserID:  null,
        assignedToUserName:  null,
        emailAddress:  null,
        sourceID: null,
        locationCount: null,
        foundUsID:  null,
        refer:  null,
        softwareID: null,
        foundUserId:  null,
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    Lead: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      sourceID: {
        required,
        minValue: minValue(1),
      },
      foundUsID: {
        required,
        minValue: minValue(1),
      },
      softwareID: {
        required,
        minValue: minValue(1),
      },
      assignedToUserID: {
        required,
        minValue: minValue(1),
      },
      reporterUserID: {
        required,
        minValue: minValue(1),
      },
    },
  },
  computed: {
    ...mapGetters('global', ['comboBox', 'comboBoxByID', 'currentUser']),
    ...mapGetters('location', ['location']),
    firstNameErrors() {
      const errors = []
      if (!this.$v.Lead.firstName.$dirty) return errors
      if (!this.$v.Lead.firstName.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.firstName.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    assignedToErrors() {
      const errors = []
      if (!this.$v.Lead.assignedToUserID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.assignedToUserID.minValue) errors.push('Pleaes user name')
      return errors
    },
    reporterUserErrors() {
      const errors = []
      if (!this.$v.Lead.reporterUserID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.reporterUserID.minValue) errors.push('Pleaes user name')
      return errors
    },
    sourceErrors() {
      const errors = []
      if (!this.$v.Lead.sourceID.$dirty) return errors
      if (!this.$v.Lead.sourceID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.sourceID.minValue) errors.push('Pleaes select source')
      return errors
    },
    softwareErrors() {
      const errors = []
      if (!this.$v.Lead.softwareID.$dirty) return errors
      if (!this.$v.Lead.softwareID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.softwareID.minValue) errors.push('Pleaes select software')
      return errors
    },
    foundUsErrors() {
      const errors = []
      if (!this.$v.Lead.foundUsID.$dirty) return errors
      if (!this.$v.Lead.foundUsID.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Lead.foundUsID.minValue) errors.push('Pleaes select software')
      return errors
    },
  },
  components: {
    DateTimePicker
  },
  watch: {
    editDialog(val) {
      this.dialog = val
      this.getAllUsers()
      this.Lead = this.lead
    }
  },  
  methods: {
    empty() {
      let newLead = {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email:null,
        businessName: null,
        notes: null,
        dueDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        statusID: 27,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        reporterUserID:  null,
        assignedToUserID:  null,
        assignedToUserName:  null,
        emailAddress:  null,
        sourceID: null,
        locationCount: null,
        foundUsID:  null,
        refer:  null,
        softwareID: null,
        foundUserId:  null,
      }
      this.Lead = newLead
      this.$v.$reset
    },
    setFollowingDate(val) {
      console.log('follow', val)
      this.Lead.dueDate = val
    },
    getAllUsers() {
      return userService.getAllCrmUser()
      .then(result => {
        this.users = result.data
      })
    },
    getActiveStore() {
      return locationService.getAll({list: 'active'})
      .then(result => {
        console.log('active result', result)
        result.data.map(row => {
          this.stores.push({
            id: row.storeID,
            name: row.CSPID + ' - ' + row.businessName
          })
        })
      })
    },
    close() {
      this.empty()
      this.$emit('close')
    },
    update() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        let contactStatus = false
        if(!this.Lead.phoneNumber) {
          if(!this.Lead.email) {
            contactStatus = false
          }else {
            contactStatus = true
          }
        } else {
          contactStatus = true
        }
        if (!contactStatus) {
          this.$swal('Lead', 'Please enter contact phone number or email address', 'warning')
        }else {
          return LeadService.update(this.Lead.id, this.Lead)
          .then(result => {
            if (result.status) {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'success',
                title: 'Lead updated!'
              })
              this.empty()
              this.$emit('updated')
              this.$emit('close')
            }
          }).catch(err => {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'error',
              title: err.data.data
            })
          })
        }
      }
    }
  }
}
</script>

<style>
.v-expansion-panel__header {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>